module.exports = __webpack_public_path__ + "media/images/flags/1x1/mex-9f9622e0a3d8b943a6211df2bdb65254.svg";